
































































import { copyToClipBoard } from "@/services";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class CreateDialog extends Vue {
  dialog = true;
  userName = "";
  alert = false;
  error = "";

  @Prop() roomCode!: string;
  @Prop() setUserName!: Function;

  onConfirm() {
    if (this.userName) {
      this.dialog = false;
      this.setUserName(this.userName);
    } else this.error = "This is a mandatory field.";
  }

  async onCopy() {
    copyToClipBoard(this.roomCode, () => {
      this.alert = true;
      setTimeout(() => (this.alert = false), 2000);
    });
  }
}
